/*
 *
 * PatientSchedule constants
 *
 */

export const FETCH_SESSIONS = 'src/PatientSchedule/FETCH_SESSIONS';
export const FETCH_SESSIONS_SUCCESS = 'src/PatientSchedule/FETCH_SESSIONS_SUCCESS';
export const FETCH_SESSIONS_FAILURE = 'src/PatientSchedule/FETCH_SESSIONS_FAILURE';

export const FETCH_PROFILE = 'src/PatientSchedule/FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'src/PatientSchedule/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'src/PatientSchedule/FETCH_PROFILE_FAILURE';
